import { generatePath } from "react-router";

import { ChillnnStudioDriver } from "@/lib/chillnn-studio-driver";
import type { Snack_SnackEditPageQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { useSnackAndHPBSnackEditUUID } from "../../../../_shared/ui/hooks/dialog/use-snack-and-HPB-snack-edit-UUID";
import { SnackBaseSettingsDialog } from "../../../_shared/ui/base-setting-dialog";
import { useInit } from "../../model/usecase/use-init";

type Props = {
	hotelID: string;
	data: Snack_SnackEditPageQuery;
};

export const DesignSnackEditUUIDSnackPresenter = ({ hotelID, data }: Props) => {
	const { editorProps: _editorProps, snackFormModel } = useInit({ hotelID, data });
	const { imageRepository, imageDeleter, imageUploader } = _editorProps;

	const { isShowBaseSettingDialog, handleClickBaseSettingSaveButton, editorProps } = useSnackAndHPBSnackEditUUID({
		pagePathAfterSaveAndExit: generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST, { hotelID }),
		editorProps: _editorProps,
		shouldTransitionBlockStatusMethods: snackFormModel.methods.shouldTransitionBlockStatusMethods,
	});

	return (
		<>
			<ChillnnStudioDriver editorProps={editorProps} shouldSync={!isShowBaseSettingDialog} />

			<SnackBaseSettingsDialog
				isShow={isShowBaseSettingDialog}
				handleClickSaveButton={handleClickBaseSettingSaveButton}
				snackFormModel={snackFormModel}
				imageRepository={imageRepository}
				imageDeleter={imageDeleter}
				imageUploader={imageUploader}
			/>
		</>
	);
};

DesignSnackEditUUIDSnackPresenter.displayName = "DesignSnackEditUUIDSnackPresenter";
